import React from 'react';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { CmsEntities, bindToContent } from 'client/data/models/cms';
import { DEFAULT_CONTENT } from 'client/data/cms/content';
import { ABOUT_EDITORS_CONTENT_FILE_PATH } from 'client/site-modules/editorial/pages/about/editors/editors';
import { EditorsSection } from 'client/site-modules/editorial/components/editors-section/editors-section';

function VehicleTestingTeamUI({ content = DEFAULT_CONTENT }) {
  return <EditorsSection editorsSection={content.child('editors-section-2')} withTitle={false} withBorder={false} />;
}

VehicleTestingTeamUI.propTypes = {
  content: CmsEntities.Content,
};

export const VehicleTestingTeam = connectToModel(VehicleTestingTeamUI, {
  content: bindToContent(ABOUT_EDITORS_CONTENT_FILE_PATH, 'editors'),
});
